// eslint-disable-next-line sonarjs/cognitive-complexity
const isSameObject = (as: object, bs: object) => {
  // eslint-disable-next-line sonarjs/no-alphabetical-sort
  const sortedA = Object.entries(as).sort() // eslint-disable-line @typescript-eslint/require-array-sort-compare
  // eslint-disable-next-line sonarjs/no-alphabetical-sort
  const sortedB = Object.entries(bs).sort() // eslint-disable-line @typescript-eslint/require-array-sort-compare
  if (sortedA.length !== sortedB.length) {
    return false
  }

  for (const [index, aRecord] of sortedA.entries()) {
    const bRecord = sortedB[index]
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition,sonarjs/different-types-comparison
    if (aRecord === undefined || bRecord === undefined) {
      // ありえないはず
      return false
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [aKey, aValue] = aRecord
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [bKey, bValue] = bRecord
    if (aKey !== bKey) {
      return false
    }

    if (Array.isArray(aValue) && Array.isArray(bValue)) {
      if (!isSameArray(aValue, bValue)) {
        return false
      }
    } else if (typeof aValue === 'object' && typeof bValue === 'object') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (!isSameObject(aValue, bValue)) {
        return false
      }
    } else if ((aValue === undefined || aValue === null) && (bValue === undefined || bValue === null)) {
      /* empty */
    } else if (JSON.stringify(aValue) !== JSON.stringify(bValue)) {
      return false
    }
  }

  return true
}

// eslint-disable-next-line sonarjs/cognitive-complexity
function isSameArray(as: unknown[], bs: unknown[]) {
  // eslint-disable-next-line sonarjs/no-alphabetical-sort
  const sortedA = [...as].sort() // eslint-disable-line @typescript-eslint/require-array-sort-compare
  // eslint-disable-next-line sonarjs/no-alphabetical-sort
  const sortedB = [...bs].sort() // eslint-disable-line @typescript-eslint/require-array-sort-compare
  if (sortedA.length !== sortedB.length) {
    return false
  }

  for (const [index, a] of sortedA.entries()) {
    const b = sortedB[index]

    if (Array.isArray(a) && Array.isArray(b)) {
      if (!isSameArray(a, b)) {
        return false
      }
    } else if (typeof a === 'object' && typeof b === 'object') {
      if (a === null || b === null) {
        if (a !== b) {
          return false
        }
        continue
      }

      if (!isSameObject(a, b)) {
        return false
      }
    } else if (JSON.stringify(a) !== JSON.stringify(b)) {
      return false
    }
  }

  return true
}

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export const parseJsonIfValid = (x: string): unknown | undefined => {
  try {
    return JSON.parse(x)
  } catch {
    return undefined
  }
}

export const generateRandomString = (length = 8): string => {
  // 生成する文字列に含める文字セット
  const chars = 'abcdefghijklmnopqrstuvwxyz'
  const charLength = chars.length
  let result = ''
  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < length; index++) {
    // eslint-disable-next-line sonarjs/pseudo-random
    result += chars[Math.floor(Math.random() * charLength)]
  }
  return result
}
